export default {
  lang: {
    zh: '中文',
    en: 'English',
    lo: 'ລາວ',
    th: 'ไทย',
    select: 'ເລືອກພາສາ',
  },
  nav: {
    home: 'ໜ້າຫຼັກ',
    services: 'ບໍລິການ',
    projects: 'ໂຄງການ',
    news: 'ຂ່າວ',
    contact: 'ຕິດຕໍ່',
    bookNow: 'ຈອງດຽວນີ້',
    menu: 'ເມນູ',
  },
  footer: {
    tagline: 'ບໍລິການປຶກສາ ແລະ ໂຄງການທີ່ເຊື່ອຖືໄດ້ ຊ່ວຍວິສາຫະກິດປັບປຸງດິຈິຕອນ.',
    quickLinks: 'ລິ້ງດ່ວນ',
    services: 'ບໍລິການ',
    projects: 'ໂຄງການ',
    news: 'ຂ່າວ',
    contact: 'ຕິດຕໍ່ພວກເຮົາ',
    contactInfo: 'ຂໍ້ມູນຕິດຕໍ່',
    email: 'ອີເມວ',
    phone: 'ໂທລະສັບ',
    workHours: 'ເວລາເຮັດວຽກ',
    copyright: '© {year} Wanyuntang. ສະຫງວນລິຂະສິດ.',
  },
  brand: {
    name: 'Wanyuntang',
    subtitle: 'ປຶກສາທຸລະກິດ · ບໍລິການໂຄງການ',
  },
  common: {
    loading: 'ກຳລັງໂຫຼດ...',
    empty: 'ບໍ່ມີຂໍ້ມູນ',
    latest: 'ຫຼ້າສຸດ',
    cancel: 'ຍົກເລີກ',
    confirm: 'ຢືນຢັນ',
    save: 'ບັນທຶກ',
    refresh: 'ໂຫຼດໃໝ່',
    refreshing: 'ກຳລັງໂຫຼດ...',
    readMore: 'ອ່ານຕໍ່ →',
    backToList: '← ກັບໄປລາຍການຂ່າວ',
    backToNews: 'ກັບໄປລາຍການ',
  },
  home: {
    badge: 'ມືອາຊີບ · ເຊື່ອຖືໄດ້ · ມີປະສິດທິພາບ',
    title: 'ຊ່ວຍວິສາຫະກິດປັບປຸງດິຈິຕອນ ແລະ ເຕີບໂຕ',
    desc: 'Wanyuntang ສະໜອງບໍລິການເວັບໄຊ, ຮ້ານຄ້າອອນໄລນ์ ແລະ ໂຄງການສະແດງຜະລິດຕະພັນ.',
    bookNow: 'ຈອງດຽວນີ້',
    learnServices: 'ເບິ່ງບໍລິການ',
    statProjects: 'ໂຄງການສຳເລັດ',
    statSatisfaction: 'ຄວາມພໍໃຈ',
    statSupport: 'ສະໜັບສະໜູນ',
    servicesTitle: 'ບໍລິການຂອງພວກເຮົາ',
    servicesSubtitle: 'ແກ້ໄຂດິຈິຕອນຄົບວົງຈອນ',
    viewAllServices: 'ເບິ່ງບໍລິການທັງໝົດ →',
    projectsTitle: 'ໂຄງການຍອດນິຍົມ',
    projectsSubtitle: 'ເລືອກປະເພດໂຄງການ ແລະ ຈອງປຶກສາ',
    newsTitle: 'ຂ່າວຫຼ້າສຸດ',
    newsSubtitle: 'ຂ່າວບໍລິສັດ ແລະ ແນວໂນ້ມອຸດສາຫະກຳ',
    ctaTitle: 'ພ້ອມເລີ່ມໂຄງການແລ້ວບໍ?',
    ctaDesc: 'ສົ່ງແບບຟອร์ມ ແລະ ທີ່ປຶກສາຈະຕິດຕໍ່ພາຍໃນ 24 ຊົ່ວໂມງ.',
    ctaBtn: 'ປຶກສາຟຣີ',
    service1Title: 'ເວັບໄຊບໍລິສັດ',
    service1Desc: 'ອອກແບບຕອບສະໜອງ, SEO, ເພີ່ມຍອດຂາຍ.',
    service2Title: 'ຮ້ານຄ້າອອນໄລນ์',
    service2Desc: 'ຈັດการສິນຄ້າ, ຄຳສັ່ງ, ແລະ ການຊຳລະເງິນ.',
    service3Title: 'ສະແດງຜະລິດຕະພັນ',
    service3Desc: 'ພາບສວຍງາມ ເນັ້ນຈຸດເດັ່ນຂອງຜະລິດຕະພັນ.',
  },
  services: {
    title: 'ບໍລິການ',
    subtitle: 'ແກ້ໄຂດິຈິຕອນຄົບວົງຈອນເພື່ອເຕີບໂຕທຸລະກິດ',
    bookConsult: 'ຈອງປຶກສາ',
    s1Title: 'ສ້າງເວັບໄຊບໍລິສັດ',
    s1Desc: 'ເວັບໄຊມືອາຊີບ ເພີ່ມຄວາມເຊື່ອຖື.',
    s1f1: 'ອອກແບບຕອບສະໜອງ',
    s1f2: 'SEO',
    s1f3: 'CMS',
    s1f4: 'ປອດໄພ ແລະ ໄວ',
    s2Title: 'ພັດທະນາຮ້ານຄ້າ',
    s2Desc: 'ຮ້ານຄ້າອອນໄລນ์ຄົບວົງຈອນ.',
    s2f1: 'ຈັດการສິນຄ້າ',
    s2f2: 'ກະຕ່າ ແລະ ຄຳສັ່ງ',
    s2f3: 'ຊຳລະເງິນ ແລະ ຂົນສົ່ງ',
    s2f4: 'ສະມາຊິກ ແລະ ການຕະຫຼາດ',
    s3Title: 'ເວັບສະແດງຜະລິດຕະພັນ',
    s3Desc: 'ພາບສວຍດຶງດູດລູກຄ້າ.',
    s3f1: 'ອອກແບບ ແລະ ແອນິເມຊັນ',
    s3f2: 'ໜ້າລາຍລະອຽດສິນຄ້າ',
    s3f3: 'ສື່ມີເດຍ',
    s3f4: 'ວິເຄາະຂໍ້ມູນ',
    s4Title: 'ທີ່ປຶກສາທຸລະກິດ',
    s4Desc: 'ປຶກສາການປ່ຽນຜ່ານດິຈິຕອນ.',
    s4f1: 'ສຳຫຼວດຄວາມຕ້ອງການ',
    s4f2: 'ອອກແບບແກ້ໄຂ',
    s4f3: 'ວາງແຜນໂຄງການ',
    s4f4: 'ສະໜັບສະໜູນຕໍ່ເนื່ອງ',
  },
  projects: {
    title: 'ໂຄງການ',
    subtitle: 'ເລືອກປະເພດໂຄງການ ແລະ ຈອງໄດ້ທັນທີ',
    empty: 'ຍັງບໍ່ມີໂຄງການ',
    bookProject: 'ຈອງໂຄງການນີ້',
  },
  projectItems: {
    building: {
      name: 'ເວັບໄຊບໍລິສັດ',
      desc: 'ເວັບໄຊບໍລິສັດຕອບສະໜອງ ເພີ່ມພາບລັກສະນະ ແລະ ລູກຄ້າໃໝ່',
    },
    cart: {
      name: 'ແພລດຟອມອີເຄມmerce',
      desc: 'ລະບົບຮ້ານຄ້າຄົບວົງຈອນ ຮອງຮັບສິນຄ້າ ຄຳສັ່ງ ແລະ ການຊຳລະ',
    },
    sparkle: {
      name: 'ເວັບສະແດງຜະລິດຕະພັນ',
      desc: 'ເວັບສະແດງຜະລິດຕະພັນສວຍງາມ ເນັ້ນຈຸດເດັ່ນ ແລະ ປະສົບການພາບ',
    },
  },
  news: {
    title: 'ຂ່າວ',
    subtitle: 'ຂ່າວອຸດສາຫະກຳ ແລະ ບໍລິສັດ',
    empty: 'ຍັງບໍ່ມີຂ່າວ',
    notFound: 'ບໍ່ພົບຂ່າວ ຫຼື ຖືກລຶບແລ້ວ',
  },
  contact: {
    title: 'ຕິດຕໍ່ພວກເຮົາ',
    subtitle: 'ຕິດຕໍ່ຜ່ານຊ່ອງທາງດ້ານລຸ່ມ ຫຼື ຈອງຜ່ານໜ້າໂຄງການ',
    emailLabel: 'ອີເມວ',
    phoneLabel: 'ສາຍດ່ວນ',
    hoursLabel: 'ເວລາເຮັດວຽກ',
    addressLabel: 'ທີ່ຢູ່',
    bookOnline: 'ຈອງອອນໄລນ์',
    formTitle: 'ຝາກຂໍ້ຄວາມ',
    formDesc: 'ກອກຂໍ້ມູນ ແລະ ພວກເຮົາຈະຕິດຕໍ່ກັບ',
    name: 'ຊື່',
    namePh: 'ຊື່ຂອງທ່ານ',
    email: 'ອີເມວ',
    emailPh: "name{'@'}example.com",
    address: 'ທີ່ຢູ່',
    addressPh: 'ທີ່ຢູ່ຂອງທ່ານ (ບໍ່ບັງຄັບ)',
    message: 'ຂໍ້ຄວາມ',
    messagePh: 'ອະທິບາຍຄວາມຕ້ອງການ',
    submit: 'ສົ່ງຂໍ້ຄວາມ',
    fillRequired: 'ກະລຸນາກອກຊື່ ແລະ ອີເມວ',
    submitSuccess: 'ໄດ້ຮັບຂໍ້ຄວາມແລ້ວ ພວກເຮົາຈະຕິດຕໍ່ກັບ!',
    submitFail: 'ສົ່ງບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່',
    defaultEmail: "contact{'@'}wanyuntang.com",
    defaultPhone: '400-888-0000',
    defaultAddress: 'ຈີນ · ສູນບໍລິການທີ່ປຶກສາທຸລະກິດ',
    defaultWorkHours: 'ຈັນ – ສຸກ 9:00 – 18:00',
  },
  appointment: {
    title: 'ຈອງໂຄງການ',
    close: 'ປິດ',
    name: 'ຊື່',
    namePh: 'ກອກຊື່ຂອງທ່ານ',
    nameErr: 'ກະລຸນາກອກຢ່າງໜ້ອຍ 2 ຕົວອັກສອນ',
    email: 'ອີເມວ',
    emailErr: 'ກະລຸນາກອກອີເມວທີ່ຖືກຕ້ອງ',
    phone: 'ໂທລະສັບ',
    phonePh: 'ບໍ່ບັງຄັບ',
    date: 'ວັນທີ',
    dateErr: 'ກະລຸນາເລືອກວັນທີ',
    slot: 'ຊ່ວງເວລາ',
    slotPh: 'ເລືອກຊ່ວງເວລາ',
    slotErr: 'ກະລຸນາເລືອກຊ່ວງເວລາ',
    address: 'ທີ່ຢູ່',
    addressPh: 'ບໍ່ບັງຄັບ',
    note: 'ໝາຍເຫດ',
    notePh: 'ອະທິບາຍຄວາມຕ້ອງການ',
    submitting: 'ກຳລັງສົ່ງ...',
    submit: 'ຢືນຢັນການຈອງ',
    success: 'ສົ່ງການຈອງແລ້ວ ພວກເຮົາຈະຕິດຕໍ່ກັບ!',
    fail: 'ສົ່ງບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່',
    datePh: 'ເລືອກວັນທີ',
    yearPh: 'ປີ',
    monthPh: 'ເດືອນ',
    dayPh: 'ວັນ',
    slot1: '09:00–10:00',
    slot2: '10:00–11:00',
    slot3: '11:00–12:00',
    slot4: '14:00–15:00',
    slot5: '15:00–16:00',
    slot6: '16:00–17:00',
  },
  admin: {
    title: 'ແຜງຄວບຄຸມ',
    subtitle: 'ລະບົບຈັດการເວັບໄຊ Wanyuntang',
    username: 'ຊື່ຜູ້ໃຊ້',
    usernamePh: 'ກອກຊື່ຜູ້ດູແລ',
    password: 'ລະຫັດຜ່ານ',
    passwordPh: 'ກອກລະຫັດຜ່ານ',
    showPwd: 'ສະແດງ',
    hidePwd: 'ເຊື່ອງ',
    remember: 'ຈື່ຊື່ຜູ້ໃຊ້',
    login: 'ເຂົ້າສູ່ລະບົບ',
    loggingIn: 'ກຳລັງເຂົ້າສູ່ລະບົບ...',
    loggedIn: 'ເຂົ້າສູ່ລະບົບແລ້ວ · {user}',
    logout: 'ອອກຈາກລະບົບ',
    loginSuccess: 'ເຂົ້າສູ່ລະບົບສຳເລັດ',
    loginFail: 'ເຂົ້າສູ່ລະບົບບໍ່ສຳເລັດ',
    fillCredentials: 'ກະລຸນາກອກຊື່ ແລະ ລະຫັດຜ່ານ',
    sessionExpired: 'ເຊດຊັນໝົດອາຍຸ ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່',
    loadFail: 'ໂຫຼດຂໍ້ມູນບໍ່ສຳເລັດ',
    appointments: 'ຈັດการການຈອງ',
    noAppointments: 'ບໍ່ມີການຈອງ',
    colName: 'ຊື່',
    colContact: 'ອີເມວ / ໂທ',
    colProject: 'ໂຄງການ',
    colTime: 'ເວລາ',
    colStatus: 'ສະຖານະ',
    colAction: 'ການດຳເนินการ',
    confirmBtn: 'ຢືນຢັນ',
    cancelBtn: 'ຍົກເລີກ',
    statusPending: 'ລໍຖ້າ',
    statusConfirmed: 'ຢືນຢັນແລ້ວ',
    statusCancelled: 'ຍົກເລີກແລ້ວ',
    statusUpdated: 'ອັບເດດສະຖານະແລ້ວ',
    updateFail: 'ອັບເດດບໍ່ສຳເລັດ',
    messages: 'ຈັດการຂໍ້ຄວາມ',
    noMessages: 'ບໍ່ມີຂໍ້ຄວາມ',
    colAddress: 'ທີ່ຢູ່',
    colMessage: 'ຂໍ້ຄວາມ',
    colCreated: 'ວັນທີສົ່ງ',
    markRead: 'ໝາຍວ່າອ່ານແລ້ວ',
    markUnread: 'ໝາຍວ່າຍັງບໍ່ອ່ານ',
    statusUnread: 'ຍັງບໍ່ອ່ານ',
    statusRead: 'ອ່ານແລ້ວ',
    contactSettings: 'ຕັ້ງຄ່າທີ່ຢູ່ຕິດຕໍ່',
    contactSettingsDesc: 'ສະແດງໃນໜ້າຕິດຕໍ່ຂອງເວັບໄຊ',
    saveContact: 'ບັນທຶກຂໍ້ມູນຕິດຕໍ່',
    contactSaved: 'ບັນທຶກຂໍ້ມູນຕິດຕໍ່ແລ້ວ',
    publishNews: 'ເຜີຍແຜ່ຂ່າວ',
    editNews: 'ແກ້ໄຂຂ່າວ',
    newsTitle: 'ຫົວຂໍ້',
    newsSummary: 'ບົດຄຳກອບ',
    newsContent: 'ເນື້ອຫາ',
    newsDate: 'ວັນທີເຜີຍແຜ່ (ເຊັ່ນ 2026-07-03)',
    publish: 'ເຜີຍແຜ່',
    saveEdit: 'ບັນທຶກການແກ້ໄຂ',
    cancelEdit: 'ຍົກເລີກການແກ້ໄຂ',
    existingNews: 'ຂ່າວທີ່ມີຢູ່',
    noNews: 'ບໍ່ມີຂ່າວ',
    edit: 'ແກ້ໄຂ',
    fillNews: 'ກະລຸນາກອກຫົວຂໍ້ ແລະ ເນື້ອຫາ',
    newsPublished: 'ເຜີຍແຜ່ຂ່າວແລ້ວ',
    newsUpdated: 'ອັບເດດຂ່າວແລ້ວ',
    opFail: 'ດຳເນີນການບໍ່ສຳເລັດ',
  },
}
